import {Component, OnInit} from '@angular/core';
import Commons from "../../commons";
import {AuthRESTService} from "../../../services/rest/auth-rest.service";
import {OAClient} from "../../../../models/oaclient";
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { SharedModule } from 'app/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule, AppWidgetModule],
    selector: 'app-oaclient-create',
    templateUrl: './oaclient-create.component.html',
    styleUrls: ['./oaclient-create.component.css']
})
export class OaclientCreateComponent extends Commons implements OnInit {
    oaclient: OAClient = new OAClient();
    errorMessage = '';

    constructor(private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
        super(toastr, translate);
    }

    ngOnInit() {
    }

    save(): void {
        this.rest.put('OAuth2/client', this.oaclient).subscribe(() => {
                this.clearNotifications().addSuccess('general.saved');
                this.errorMessage = '';
            }, err => this.errorHandler(err)
        )
    }

}
